// TODO check all events and add more if there are any

/**
 * Add functions for Snapchat Ads
 * */

(function (wpm, $, undefined) {


}(window.wpm = window.wpm || {}, jQuery));

/**
 * Execute as soon as possible
 * */

(function () {
	//
	//
	// if ('order_received_page' === wpmDataLayer.shop.page_type && wpmDataLayer?.order?.google?.ads?.enhanced_conversion_data) {
	// 	var enhanced_conversion_data_2 = wpmDataLayer.order.google.ads.enhanced_conversion_data;
	// }

})()

